import { getAllUsers } from '@api/services/user.service';
import { useQuery } from '@tanstack/react-query';
import { InternalSupportUser } from '../helpers/internal-support.types';

const useInternalSupportUsers = () => {
    return useQuery<InternalSupportUser[]>(['pulse-internal-support-users'], async () => {
        const users = await getAllUsers();

        return users.map((user) => ({
            _id: user._id,
            name: user.name,
            username: user.username,
            dpUrl: user.dpUrl,
        }));
    });
};

export default useInternalSupportUsers;
